import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue' 
import End from '../views/End.vue'

Vue.use(VueRouter)

import app_data from '../data/questions.js'; 
console.log('/'+app_data.end_at);
const routes = [
  {
    path: '/',
    name: 'Select language',
    component: Home
  },
  {
    path: '/'+app_data.end_at,
    name: 'End',
    component: End
  },
  {
    path: '/:locale',
    name: 'Farmer 4.0 - First Question',
    component: Home
  },
  {
    path: '/:locale/'+app_data.end_at,
    name: 'End',
    component: End
  },
  {
    path: '/:locale/:step',
    name: 'Farmer 4.0 - Test',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
